import { driveInOut, trainInOut, walkInOut } from "../../constants/reducers";
import {
  REQUEST_COMPANIES,
  RECEIVE_COMPANIES,
  FAILED_COMPANIES,
} from "../../constants/actionTypes";
import { get, filter, size } from "lodash";

export const fetchCompanies = (name) => {
  return async (dispatch, getState) => {
    dispatch({
      type: REQUEST_COMPANIES,
      name,
    });
    try {
      let companies = get(getState(), ["user", "companies"]);
      console.log(`reducers/companies >> Setting up list of companies/sites for name="${name}"`);
      companies = filter(
        companies,
        (c) =>
          size(
            filter(
              get(c, ["sites"]),
              (s) =>
                size(
                  filter(get(s, ["zones"]), (z) =>
                    name === driveInOut
                      ? z.is_vehicle_access
                      : name === walkInOut
                      ? z.is_human_access
                      : name === trainInOut
                      ? z.is_train_access
                      : true
                  )
                ) > 0
            )
          ) > 0
      );
      dispatch({
        type: RECEIVE_COMPANIES,
        name,
        payload: companies,
      });
    } catch (e) {
      console.log(e);
      dispatch({
        type: FAILED_COMPANIES,
        name,
        payload: "Failed to load data.",
      });
    }
  };
};
